import React from 'react';
import AllNotificationsIcon from '../../assets/Svg/AllNotificationsIcon';
import UnreadNotificationsIcon from '../../assets/Svg/UnreadNotificationsIcon';
import MentionIcon from '../../assets/Svg/MentionIcon';

export const NOTIFICATION_TAB = {
    ALL: 'ALL',
    UNREAD: 'UNREAD',
    MENTIONS: 'MENTIONS',
} as const;

export const NOTIFICATION_CATEGORY = {
    LEAD: 'LEAD',
    DEAL: 'DEAL',
} as const;

export const NOTIFICATION_CATEGORY_LABEL = {
    LEAD: 'Lead',
    DEAL: 'Deal',
} as const;

export const NOTIFICATION_VERB = {
    ADDED: 'added a new comment',
    MENTIONED: 'mentioned you in a comment',
} as const;

export const NOTIFICATION_PAGE_SIZE = 50;
export const UNREAD_POLL_INTERVAL_MS = 15_000;
// Pixels-from-bottom at which infinite scroll fires the next page fetch.
export const INFINITE_SCROLL_THRESHOLD_PX = 120;

export const BADGE_MAX_COUNT = 99;
export const BADGE_OVERFLOW_LABEL = '99+';

export const TAB_ACTIVE_COLOR = '#6021B3';
export const TAB_INACTIVE_COLOR = '#9D9D9D';

export const TAB_ICON: Record<string, React.FC<{ color?: string }>> = {
    [NOTIFICATION_TAB.ALL]: AllNotificationsIcon,
    [NOTIFICATION_TAB.UNREAD]: UnreadNotificationsIcon,
    [NOTIFICATION_TAB.MENTIONS]: MentionIcon,
};

export const TABS: { id: (typeof NOTIFICATION_TAB)[keyof typeof NOTIFICATION_TAB]; label: string }[] = [
    { id: NOTIFICATION_TAB.ALL, label: 'All' },
    { id: NOTIFICATION_TAB.UNREAD, label: 'Unread' },
    { id: NOTIFICATION_TAB.MENTIONS, label: 'Mentions' },
];
